import { render, staticRenderFns } from "./Equipment.vue?vue&type=template&id=bc1d1ff4"
import script from "./Equipment.vue?vue&type=script&lang=js"
export * from "./Equipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports